import { useNavigate } from "react-router";
import { PropsWithChildren } from "react";

import { trackEvent } from "@/lib/mixpanel";

interface StubPageProps extends PropsWithChildren {
  title: string;
  description: string;
}

export const StubPage = ({ title, description, children }: StubPageProps) => {
  const navigate = useNavigate();

  return (
    <div className="mx-auto flex max-w-5xl flex-col gap-4 px-4 py-10">
      <button
        onClick={() => {
          navigate(-1);
          trackEvent("Navigation Clicked", {
            link_name: "back",
            to_page: "back",
          });
        }}
        className="group inline-flex items-center gap-2 text-sm font-semibold text-slate-700 transition hover:text-slate-900"
      >
        <span className="rounded-full bg-slate-100 px-2 py-1 text-xs transition group-hover:bg-slate-200">
          ←
        </span>
        Back
      </button>
      <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
        <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
        <p className="mt-2 max-w-3xl text-base text-slate-600">{description}</p>
        {children ? <div className="mt-4">{children}</div> : null}
      </div>
    </div>
  );
};
